import React, { FC } from 'react';
import { VerticalTimeline } from 'react-vertical-timeline-component';
import { createUseStyles } from '../../../../../../../../theming';
import { Item } from '../../../../../../../../interfaces/api/ActivityWall';
import { Order } from '../../../../../../../../interfaces/Table';
import TimelineElement from './components/TimelineElement';

const useStyles = createUseStyles({
  root: {
    '&:before': {
      background: '#e8e8e8',
    },
  },
});

interface Props {
  items: Item[];
  wallId: string;
  order: Order;
}

const Timeline: FC<Props> = ({ wallId, items, order }) => {
  const classes = useStyles();

  const sortByDate = (a, b) => {
    if (order === 'asc') {
      // @ts-ignore
      return new Date(a.createdAt) - new Date(b.createdAt);
    } else {
      // @ts-ignore
      return new Date(b.createdAt) - new Date(a.createdAt);
    }
  };

  return (
    <VerticalTimeline className={classes.root}>
      {items.sort(sortByDate).map((item) => (
        <TimelineElement wallId={wallId} item={item} key={item.id} />
      ))}
    </VerticalTimeline>
  );
};

export default Timeline;
